<template>
  <!-- 股东/董事信息 - 公司类型表单面板(弹窗编辑/回显平铺 复用) -->
  <el-form
    ref="formRef"
    :model="form"
    :rules="rules"
    label-position="top"
    :disabled="isReadonly"
    :class="{ readOnlyStyle: isReadonly }"
    class="companyForm"
  >
    <div class="postType">
      <el-form-item>
        <el-radio-group v-model="form.positionHeld">
          <el-radio label="SHAREHOLDER">{{ $t("enroll.intitle.type01") }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </div>
    <el-row :gutter="20" class="pt22">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.licenseName')" prop="fullName" ref="fullName">
          <el-input v-model="form.fullName" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.country')" prop="nationality" ref="nationality">
          <el-select v-model="form.nationality" :placeholder="$t('common.placeholder.select')" filterable class="wdb100">
            <el-option v-for="item of globalFormatList('countryList')" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.license')" prop="businessLicenseNo" ref="businessLicenseNo">
          <el-input v-model="form.businessLicenseNo" :placeholder="$t('common.placeholder.enter')" v-regexFilter="$halfWidthRegex" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.phone')" prop="phone" ref="phone">
          <prefix-phone v-model="form.phone" class="wdb100"></prefix-phone>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.email')" prop="email" ref="email">
          <el-input v-model="form.email" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="!isMalaysia">
        <el-form-item :label="$t('enroll.intitle.site')" prop="registeredOfficeAddress" ref="registeredOfficeAddress">
          <el-input v-model="form.registeredOfficeAddress" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.location')" prop="operationAddress" ref="operationAddress">
          <el-input v-model="form.operationAddress" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.incorporationDate')" prop="incorporationDate" ref="incorporationDate">
          <el-date-picker
            v-model="form.incorporationDate"
            type="date"
            :placeholder="$t('common.placeholder.select')"
            value-format="yyyy-MM-dd"
            class="wdb100"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.isNomineeShareholder')" prop="isNominatedShareholder" ref="isNominatedShareholder">
          <el-select v-model="form.isNominatedShareholder" :placeholder="$t('common.placeholder.select')" class="wdb100">
            <el-option :value="1" :label="$t('common.yes')"></el-option>
            <el-option :value="0" :label="$t('common.no')"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- 马来西亚专属 - 公司额外信息 -->
      <template v-if="isMalaysia">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.entityType')" prop="entityType" ref="entityType">
            <el-select v-model="form.entityType" :placeholder="$t('common.placeholder.select')" class="wdb100">
              <el-option
                v-for="item of byCountryFormatList('entityTypeData')"
                :key="`companyEntityType-${item.value}`"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.companyRegistrationNumber')" prop="companyRegistrationNumber" ref="companyRegistrationNumber">
            <el-input v-model="form.companyRegistrationNumber" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.companyType')" prop="companyType" ref="companyType">
            <el-select v-model="form.companyType" :placeholder="$t('common.placeholder.select')" class="wdb100">
              <el-option v-for="item of byCountryFormatList('companyTypeData')" :key="`companyType-${item.value}`" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.placeOfIncorporation')" prop="placeOfIncorporation" ref="placeOfIncorporation">
            <el-input v-model="form.placeOfIncorporation" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <!-- 马来西亚专属 - REGISTERED ADDRESS -->
    <div class="wdb100 pt20" v-if="isMalaysia">
      <div class="lh40 fs13 black45 fwb postType">
        {{ $t("enroll.intitle.malaysia.registeredAddressTitle") }}
      </div>
      <el-row :gutter="20" class="pt22">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.addressLine1')" prop="registeredAddressLine1" ref="registeredAddressLine1">
            <el-input v-model="form.registeredAddressLine1" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.addressLine2')" prop="registeredAddressLine2" ref="registeredAddressLine2">
            <el-input v-model="form.registeredAddressLine2" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.addressLine3')" prop="registeredAddressLine3" ref="registeredAddressLine3">
            <el-input v-model="form.registeredAddressLine3" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.city')" prop="registeredAddressCity" ref="registeredAddressCity">
            <el-input v-model="form.registeredAddressCity" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.state')" prop="registeredAddressState" ref="registeredAddressState">
            <el-input v-model="form.registeredAddressState" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.postcode')" prop="registeredAddressPostalCode" ref="registeredAddressPostalCode">
            <el-input v-model="form.registeredAddressPostalCode" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.country')" prop="registeredAddressCountry" ref="registeredAddressCountry">
            <el-select v-model="form.registeredAddressCountry" :placeholder="$t('common.placeholder.select')" filterable class="wdb100">
              <el-option v-for="item of globalFormatList('countryList')" :key="`companyRegCountry-${item.value}`" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <!-- 马来西亚专属 - SERVICE ADDRESS -->
    <div class="wdb100 pt20" v-if="isMalaysia">
      <div class="lh40 fs13 black45 fwb postType fxVer jcsb">
        <span>{{ $t("enroll.intitle.malaysia.serviceAddressTitle") }}</span>
        <el-checkbox v-model="form.serviceAddressType" :true-label="1" :false-label="2" class="sameAddressCheckbox">
          {{ $t("enroll.intitle.malaysia.sameAsRegisteredAddress") }}
        </el-checkbox>
      </div>
      <template v-if="form.serviceAddressType !== 1">
        <el-row :gutter="20" class="pt22">
          <el-col :span="12">
            <el-form-item :label="$t('enroll.intitle.malaysia.addressLine1')" prop="serviceAddressLine1" ref="serviceAddressLine1">
              <el-input v-model="form.serviceAddressLine1" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('enroll.intitle.malaysia.addressLine2')" prop="serviceAddressLine2" ref="serviceAddressLine2">
              <el-input v-model="form.serviceAddressLine2" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('enroll.intitle.malaysia.addressLine3')" prop="serviceAddressLine3" ref="serviceAddressLine3">
              <el-input v-model="form.serviceAddressLine3" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('enroll.intitle.malaysia.city')" prop="serviceAddressCity" ref="serviceAddressCity">
              <el-input v-model="form.serviceAddressCity" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('enroll.intitle.malaysia.state')" prop="serviceAddressState" ref="serviceAddressState">
              <el-input v-model="form.serviceAddressState" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('enroll.intitle.malaysia.postcode')" prop="serviceAddressPostalCode" ref="serviceAddressPostalCode">
              <el-input v-model="form.serviceAddressPostalCode" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('enroll.intitle.malaysia.country')" prop="serviceAddressCountry" ref="serviceAddressCountry">
              <el-select v-model="form.serviceAddressCountry" :placeholder="$t('common.placeholder.select')" filterable class="wdb100">
                <el-option v-for="item of globalFormatList('countryList')" :key="`companySvcCountry-${item.value}`" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </div>
    <!-- representative (主体代表) -->
    <div class="wdb100 pt20" v-if="form.positionHeld === 'SHAREHOLDER'">
      <div class="lh40 fs13 black45 fwb postType">
        {{ $t("enroll.intitle.representative") }}
      </div>
      <el-row :gutter="20" class="pt22">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.cardName')" prop="representativeInfo.fullName" ref="representativeInfo.fullName">
            <el-input v-model="form.representativeInfo.fullName" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.nationality')" prop="representativeInfo.nationality" ref="representativeInfo.nationality">
            <el-select v-model="form.representativeInfo.nationality" :placeholder="$t('common.placeholder.select')" filterable class="wdb100">
              <el-option
                v-for="item of globalFormatList('nationalityList')"
                :key="`representativeNationality-${item.value}`"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.cardType')" prop="representativeInfo.identificationType" ref="representativeInfo.identificationType">
            <el-select v-model="form.representativeInfo.identificationType" :placeholder="$t('common.placeholder.select')" class="wdb100">
              <el-option v-for="item of byCountryFormatList('identificationData')" :key="`company-${item.value}`" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.cardNo')" prop="representativeInfo.identificationNo" ref="representativeInfo.identificationNo">
            <el-input
              v-model="form.representativeInfo.identificationNo"
              :placeholder="$t('common.placeholder.enter')"
              v-regexFilter="$halfWidthRegex"
              class="wdb100"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.phone')" prop="representativeInfo.phone" ref="representativeInfo.phone">
            <prefix-phone v-model="form.representativeInfo.phone" class="wdb100"></prefix-phone>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.email')" prop="representativeInfo.email" ref="representativeInfo.email">
            <el-input v-model="form.representativeInfo.email" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.address')" prop="representativeInfo.residentialAddress" ref="representativeInfo.residentialAddress">
            <el-input v-model="form.representativeInfo.residentialAddress" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.birthDate')" prop="representativeInfo.birthDate" ref="representativeInfo.birthDate">
            <el-date-picker
              v-model="form.representativeInfo.birthDate"
              type="date"
              :placeholder="$t('common.placeholder.select')"
              value-format="yyyy-MM-dd"
              class="wdb100"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <!-- 股份信息表格 - 使用子组件 -->
    <shares-table :value="form" @input="handleSharesInput" :isReadonly="isReadonly" :isMalaysia="isMalaysia" />
  </el-form>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import SharesTable from "./SharesTable.vue";
import { validateFormLocation } from "@/utils/common";
import { mapState, mapGetters } from "vuex";

// 可选业务类型集合（用于判断字段是否必填）
const OPTIONAL_BUSINESS_TYPES = ["COMPREHENSIVE_CUSTOMIZED", "FUND_ADMIN_CUSTOMIZED"];

export default {
  name: "ShareholderDirectorCompanyFormPanel",
  mixins: [validatorMixin],
  components: { SharesTable },
  props: {
    /** 表单数据对象(弹窗模式: companyForm; 回显模式: 股东/董事row) */
    form: { type: Object, required: true },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    /** 是否马来西亚（用于显示马来专属的注册地址/服务地址模块） */
    isMalaysia: { type: Boolean, default: false },
  },
  computed: {
    ...mapState("applyment", ["applymentDetail"]),
    ...mapGetters("constant", ["globalFormatList", "byCountryFormatList"]),
    /** 判断当前是否为可选字段模式（COMPREHENSIVE_CUSTOMIZED / FUND_ADMIN_CUSTOMIZED） */
    isOptionalField() {
      return OPTIONAL_BUSINESS_TYPES.includes(this.applymentDetail.businessType);
    },
    rules() {
      const opt = this.isOptionalField;
      return {
        fullName: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        nationality: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        businessLicenseNo: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        phone: [{ required: !opt, validator: this.validatePhone, trigger: "submit" }],
        email: [
          { required: !opt, message: this.$t("common.placeholder.enter"), trigger: "submit" },
          { type: "email", message: this.$t("common.regular.email"), trigger: "submit" },
        ],
        registeredOfficeAddress: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        operationAddress: [
          {
            required: opt || this.applymentDetail.businessType === "COMPANY_INCORPORATION" ? false : true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        incorporationDate: [{ required: !opt, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        isNominatedShareholder: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        information: [{ required: true, message: this.$t("common.placeholder.replenish"), trigger: "submit" }],
        // 主体代表校验规则
        representativeInfo: {
          fullName: [{ required: !opt, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
          nationality: [{ required: !opt, message: this.$t("common.placeholder.select"), trigger: "submit" }],
          identificationType: [{ required: !opt, message: this.$t("common.placeholder.select"), trigger: "submit" }],
          identificationNo: [{ required: !opt, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
          email: [
            { required: !opt, message: this.$t("common.placeholder.enter"), trigger: "submit" },
            { type: "email", message: this.$t("common.regular.email"), trigger: "submit" },
          ],
          phone: [{ required: !opt, validator: this.validatePhone, trigger: "submit" }],
          residentialAddress: [{ required: !opt, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
          birthDate: [{ required: false, validator: this.validateBirthday, trigger: "submit" }],
        },
        // 马来西亚专属 - 公司额外信息校验
        companyRegistrationNumber: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        // 马来西亚专属 - 注册地址/服务地址校验
        registeredAddressLine1: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        serviceAddressLine1: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
      };
    },
  },
  methods: {
    /** 清除校验状态(供父组件通过ref调用) */
    clearValidate() {
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate();
      });
    },
    /** 供父组件触发表单校验 */
    validate(callback) {
      this.$refs.formRef.validate((valid, object) => {
        if (!valid) validateFormLocation(object, this.$refs.formRef);
        callback && callback(valid);
      });
    },
    /**
     * SharesTable 返回深拷贝后的新对象(仅 sharesInfo 变化)，
     * form 是 prop 不能整体替换，将变更同步回原对象以保持父组件引用
     */
    handleSharesInput(val) {
      if (!val) return;
      this.$set(this.form, "sharesInfo", val.sharesInfo || []);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 表单项基础样式(与弹窗内展示保持一致) */
.companyForm ::v-deep {
  .el-form-item__label {
    line-height: 1em;
    padding: 0 0 8px;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-radio {
    margin-right: 18px;
  }
  .el-radio:last-child {
    margin-right: 0;
  }
  .el-radio__label {
    padding-left: 5px;
  }
  /* 数字输入框 spinner 隐藏 */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    appearance: none !important;
  }
  input[type="number"] {
    appearance: textfield !important;
  }
}
.postType {
  width: 100%;
  height: 40px;
  background: #f4f8fe;
  padding: 0 20px;
}
.postType ::v-deep .el-form-item__content {
  line-height: 40px;
}
/* 自适应的"与注册地址相同"复选框：抵消外部 .dataForm ::v-deep .el-checkbox 的固定宽度 */
.sameAddressCheckbox {
  width: auto !important;
  margin-right: 0 !important;
  padding-right: 0 !important;
}
</style>
